import Cookies from 'js-cookie';

export const signOutAdmin = (callBack) => {
  Cookies.remove('adminToken');
  // Cookies.remove('roleID');
  Cookies.remove('accessTokenIdAdmin');
  setTimeout(callBack, 100);
}
